import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { takeUntil } from 'rxjs';
import { CRITERION_TYPE } from '../../const';
import { CriterionAddMembersModel, ICriterion } from '../../models/criterion';
import { CriterionAddVisitMember, IMember } from '../../models/member';
import { DistributeService } from '../../services/distribute.service';
import { BaseComponent } from '../base.component';
@Component({
  selector: 'app-criterions-tab',
  templateUrl: './criterions-tab.component.html',
  styleUrls: ['./criterions-tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CriterionsTabComponent extends BaseComponent implements OnInit {
  selectedCriterion: ICriterion;
  criterions: ICriterion[] = [];
  @Output() isValid = new EventEmitter<boolean>();
  constructor(private distributeService: DistributeService) {
    super();
  }

  ngOnInit(): void {
    this._initTree();
  }

  private _initTree() {
    this.distributeService
      .getCriterionByVisitKey(this.visitInfo.key)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.criterions = res;
        this.isValid.emit(res.length ? this._checkIfCriterionsIsValid(res) : false);
      });
  }

  changeCriterions(event: ICriterion) {
    this.selectedCriterion = event;
  }

  onAdd(items: IMember[]) {
    const data = this._prepareDataToServe(items);
    this.distributeService
      .addCriterionMembers(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this._initTree();
      });
  }

  onRemove(items: IMember[]) {
    const data = this._prepareDataToServe(items);
    this.distributeService
      .deleteCriterionMembers(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this._initTree();
      });
  }

  private _checkIfCriterionsIsValid(data = this.criterions, parent: ICriterion = null) {
    return data?.every((d) => {
      if (d.criterionType == CRITERION_TYPE) {
        return !!parent?.visitMembers.length;
      }
      if (!d?.subCriteria || d.subCriteria?.length === 0) {
        return !!d.visitMembers.length;
      }
      return this._checkIfCriterionsIsValid(d.subCriteria , d) && !!d.visitMembers.length;
    });
  }

  private _prepareDataToServe(items: IMember[]): CriterionAddMembersModel {
    return {
      ...this.selectedCriterion,
      visitMembers: items.map((data) => this._mapMemberToModel(data)),
    };
  }
  private _mapMemberToModel(member: IMember): CriterionAddVisitMember {
    return {
      generatedId: this.data.generatedId,
      id: member.id,
      requestId: this.visitInfo.requestId,
      reviewerId: member.reviewer.id,
      role: member.role,
      visitId: this.visitInfo.id,
      visitKey: this.visitInfo.key,
    };
  }
}
